import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement, LightDomStyles } from '@phase2/outline-core';
import componentStyles from './outline-button-baseline.css.lit';

/**
 * The Outline Button component
 * @element outline-button-baseline
 * @slot - default slot, used for everything.
 */

@customElement('outline-button-baseline')
export class OutlineButtonBaseline extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-button-baseline': OutlineButtonBaseline;
  }
}
